/**
 * API-Fehlercodes robust lesen — axios-Rohfehler und buildError()-Shape (Interceptor).
 */

function up(v) {
  return String(v ?? "").trim().toUpperCase();
}

export function getApiErrorStatus(err) {
  const s = err?.status ?? err?.response?.status;
  return Number.isFinite(Number(s)) ? Number(s) : null;
}

export function getApiErrorCode(err) {
  const data = err?.data ?? err?.response?.data;
  if (data != null) {
    if (typeof data === "string" && /^[A-Z][A-Z0-9_]*$/.test(up(data))) return up(data);
    if (typeof data?.code === "string" && /^[A-Z][A-Z0-9_]*$/.test(up(data.code))) return up(data.code);
    if (typeof data?.error === "string" && /^[A-Z][A-Z0-9_]*$/.test(up(data.error))) return up(data.error);
    if (data?.error && typeof data.error === "object" && typeof data.error.code === "string") {
      return up(data.error.code);
    }
  }
  if (typeof err?.code === "string" && /^[A-Z][A-Z0-9_]*$/.test(up(err.code))) return up(err.code);
  if (typeof err?.message === "string" && /^[A-Z][A-Z0-9_]*$/.test(up(err.message))) return up(err.message);
  return "";
}

export function isNotAssignedError(err) {
  const code = getApiErrorCode(err);
  const msg = up(err?.message);
  const hit = code === "NOT_ASSIGNED" || msg.includes("NOT_ASSIGNED");
  if (!hit) return false;
  // Status oft 403; nach buildError() gelegentlich nur message/data → trotzdem erkennen
  const s = getApiErrorStatus(err);
  return s == null || s === 403;
}

export function emitEntityAccessDenied(detail = {}) {
  try {
    window.dispatchEvent(new CustomEvent("entity-access-denied", { detail }));
  } catch {
    /* ignore */
  }
}
